<div fxLayout="column" fxLayoutGap="5px" class="desktop">
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px">
        <div fxFlex="50%" i18n>
            <input type="checkbox" [checked]="checkboxes[RADAR]" (change)="toggleCheckbox('RADAR')"><img src="assets/img/RADAR.svg" alt="Radars">Radares
        </div>
        <div fxFlex="50%" i18n>
            <input type="checkbox" [checked]="checkboxes[GAS_STATION]" (change)="toggleCheckbox('GAS_STATION')"><img src="assets/img/GAS_STATION.svg" alt="Gasolineres">Gasolineras
        </div>
    </div>
    <div fxLayout="row" fxLayoutGap="15px">
        <div fxFlex="50%" i18n>
            <input type="checkbox" [checked]="checkboxes[TRAMS_PERILL]" (change)="toggleCheckbox('TRAMS_PERILL')"> <img src="assets/img/ROAD.svg" alt="Trams de perill">Tramos de peligro
        </div>
        <div fxFlex="50%" i18n>
            <input type="checkbox" [checked]="checkboxes[PARKING]" (change)="toggleCheckbox('PARKING');"> <img src="assets/img/PARKING.svg" alt="Pàrkings">Párkings
        </div>
    </div>
</div>

<!------------------------------------------------------------------------------------------------------------------------------->


<div fxLayout="column" class="responsive-landscape-container" fxLayoutAlign="space-between center" fxLayoutGap="13px">

    <div class="alerta-button" (click)="toggleCheckbox('RADAR')" [class.checked]="checkboxes[RADAR]" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="5px">
        <img src="assets/img/RADAR.svg" width="25px">
        <div i18n>
            Radares
        </div>
    </div>

    <div class="alerta-button" (click)="toggleCheckbox('GAS_STATION')" [class.checked]="checkboxes[GAS_STATION]" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="5px">
        <img src="assets/img/GAS_STATION.svg" width="25px">
        <div i18n>
            Gasolineras
        </div>
    </div>

    <div class="alerta-button" (click)="toggleCheckbox('TRAMS_PERILL')" [class.checked]="checkboxes[TRAMS_PERILL]" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="5px">
        <img src="assets/img/ROAD.svg" width="25px">
        <div i18n>
            Peligro
        </div>
    </div>

    <div class="alerta-button" (click)="toggleCheckbox('PARKING')" [class.checked]="checkboxes[PARKING]" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="5px">
        <img src="assets/img/PARKING.svg" width="25px">
        <div  i18n>
            Incidencias
        </div>
    </div>


</div>

<!----------------------------------------------------------------------------------------------------------------------------------->

<div fxLayout="row" class="responsive-container" fxLayoutAlign="space-between center" fxLayoutGap="13px">

    <div class="alerta-button" (click)="toggleCheckbox('RADAR')" [class.checked]="checkboxes[RADAR]" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="5px">
        <img src="assets/img/RADAR.svg" width="25px">
        <div i18n>
            Radares
        </div>
    </div>

    <div class="alerta-button" (click)="toggleCheckbox('GAS_STATION')" [class.checked]="checkboxes[GAS_STATION]" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="5px">
        <img src="assets/img/GAS_STATION.svg" width="25px">
        <div  i18n>
            Gasolineras
        </div>
    </div>

    <div class="alerta-button" (click)="toggleCheckbox('TRAMS_PERILL')" [class.checked]="checkboxes[TRAMS_PERILL]" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="5px">
        <img src="assets/img/ROAD.svg" width="25px">
        <div i18n>
            Peligro
        </div>
    </div>

    <div class="alerta-button" (click)="toggleCheckbox('PARKING')" [class.checked]="checkboxes[PARKING]" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="5px">
        <img src="assets/img/PARKING.svg" width="25px">
        <div i18n>
            Incidencias
        </div>
    </div>

    

</div>